import { useRef, useEffect, forwardRef, useState } from 'react';

import styles from './New_InputTextComponent.module.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons';

const New_InputTextComponent = forwardRef((props, ref) => {
    var {
        onFocus, onBlur, type, focused = false, iconPosition = "left", icon = "", withDelete = false, value, keyboardOpenAt, onChange, keyboardRef, type, placeHolder,
        styleType, fontSize, width, height, marginTop, marginBottom, marginLeft, typeOfInput = "text", onEnterClicked, isChat = false
    } = props;

    const caretPosition = useRef();
    const currentKeyboard = useRef();
    const lastValue = useRef();
    const componentInstance = useRef(null);
    const withRightIcon = useRef();
    const withLeftIcon = useRef();

    const [rightIcon, setRightIcon] = useState();
    const [keyboardClicked, setKeyboardClicked] = useState(false);
    const [selected, setSelected] = useState(false);
    const [canDelete, setCanDelete] = useState(false);
    const [currentType, setCurrentType] = useState(type);


    useEffect(() => {
        componentInstance.current = ref.current;
        ref.current.value = value;
        lastValue.current = "";
        withRightIcon.current = false;
        withLeftIcon.current = false;

        ref.current.keyboardOpenAt = keyboardOpenAt;
        ref.current.setKeyboardClicked = () => {
            setKeyboardClicked(true);
        };

        ref.current.enterClicked = () => {
            if (!caretPosition.current) {
                caretPosition.current = ref.current.selectionStart;
            }
            onEnterClicked?.();
        };

        ref.current.addToValue = (key) => {
            if (typeOfInput !== "number") {
                let start = ref.current.selectionStart;
                let end = ref.current.selectionEnd;

                const newValue = ref.current.value.slice(0, start) + key + ref.current.value.slice(end);
                ref.current.value = newValue;
                const newCursorPosition = start + key.length;
                ref.current.setSelectionRange(newCursorPosition, newCursorPosition);
            } else {
                if ((!isNaN(key) || key === ".") && ref.current.value.length < 9) {

                    let start = ref.current.selectionStart;
                    let end = ref.current.selectionEnd;

                    const newValue = ref.current.value.slice(0, start) + key + ref.current.value.slice(end);
                    ref.current.value = newValue;
                    const newCursorPosition = start + key.length;
                    ref.current.setSelectionRange(newCursorPosition, newCursorPosition);
                }
            }

            const inputEvent = new Event('input', { bubbles: true });
            ref.current.dispatchEvent(inputEvent);

            onTextChanged();
        };

        ref.current.removeOneFromValue = () => {
            if (typeOfInput !== "number") {
                let start = ref.current.selectionStart;
                let end = ref.current.selectionEnd;

                if (start === end) {
                    // Șterge un caracter înainte de cursor
                    if (start > 0) {
                        const newValue = ref.current.value.slice(0, start - 1) + ref.current.value.slice(end);
                        ref.current.value = newValue;
                        ref.current.setSelectionRange(start - 1, start - 1);
                    }
                } else {
                    // Șterge textul selectat
                    const newValue = ref.current.value.slice(0, start) + ref.current.value.slice(end);
                    ref.current.value = newValue;
                    ref.current.setSelectionRange(start, start);
                }
            } else {
                let start = ref.current.selectionStart;
                let end = ref.current.selectionEnd;

                if (start === end) {
                    // Șterge un caracter înainte de cursor
                    if (start > 0) {
                        const newValue = ref.current.value.slice(0, start - 1) + ref.current.value.slice(end);
                        ref.current.value = newValue;
                        ref.current.setSelectionRange(start - 1, start - 1);
                    }
                } else {
                    // Șterge textul selectat
                    const newValue = ref.current.value.slice(0, start) + ref.current.value.slice(end);
                    ref.current.value = newValue;
                    ref.current.setSelectionRange(start, start);
                }
            }

            const inputEvent = new Event('input', { bubbles: true });
            ref.current.dispatchEvent(inputEvent);

            onTextChanged();
        };

        if (icon) {
            if (iconPosition === "right") {
                withRightIcon.current = true;
                setRightIcon(icon);
            } else {
                withLeftIcon.current = true;
                if (withDelete) {
                    withRightIcon.current = true;
                }
            }
        }

        if (type === "password") {
            withRightIcon.current = true;
            setRightIcon(byPrefixAndName.fas["eye"]);
        }

        if (focused) {
            ref.current.focus();
        }

        currentKeyboard.current = keyboardRef.current;

        setTimeout(() => {
            keyboardRef.current?.addInputElement(ref.current);
        }, 100)

        return () => {
            currentKeyboard.current?.removeInputElement(componentInstance.current);
        }
    }, [])

    useEffect(() => {
        if (focused) {
            setTimeout(() => {
                ref.current.focus();
            }, 100)
        }
    }, [focused])


    useEffect(() => {
        if (icon) {
            if (iconPosition === "right") {
                withRightIcon.current = true;
                setRightIcon(icon);
            } else {
                withLeftIcon.current = true;
                if (withDelete) {
                    withRightIcon.current = true;
                }
            }
        }
    }, [icon])

    const onTextChanged = () => {
        if (type !== "password") {
            if (withRightIcon.current) {
                if (withLeftIcon.current) {
                    if (ref.current.value) {
                        setRightIcon(byPrefixAndName.fas["close"]);
                        setCanDelete(true);
                    } else {
                        setRightIcon(null);
                        setCanDelete(false);
                    }
                } else {
                    if (ref.current.value) {
                        setRightIcon(byPrefixAndName.fas["close"]);
                        setCanDelete(true);
                    } else {
                        setRightIcon(icon);
                        setCanDelete(false);
                    }
                }
            }
        }

        if (typeOfInput === "number" && ref.current.value.length > 9) {
            ref.current?.removeOneFromValue()
        }

        if (typeOfInput === "currencyName" && ref.current.value.length > 5) {
            ref.current?.removeOneFromValue()
        }

        if (onChange) {
            if (lastValue.current !== ref.current.value) {
                onChange?.(ref.current?.value);
                lastValue.current = ref.current.value;
            }
        }
    }

    const getClassName = (styleType) => {
        switch (styleType) {
            case 'SRCH':
                return styles.search_input;
            case 'EDT':
                return styles.editName;
            case 'POPUP':
                return styles.inputPopup;
            case 'SEARCHPOPUP':
                return styles.searchPopup;
            case 'CONFERENCE':
                return styles.conference;
            case 'FILES':
                return styles.files;
            case 'CURRENCY':
                return styles.currency;
            case 'CURRENCY_DD':
                return styles.currencyDd;
            case 'NOTESEMAIL':
                return styles.noteEmail;
            default:
                return styles.input;
        }
    };

    const ClickDeleteButton_Handler = () => {
        if (canDelete) {
            if (ref.current.value) {
                ref.current.value = "";
                onTextChanged();
            }
            ref.current.focus();
        }
    }

    const ShowHidePassword_handler = () => {
        if (currentType === "text") {
            setCurrentType("password");
            setRightIcon(byPrefixAndName.fas["eye"]);
        } else {
            setCurrentType("text");
            setRightIcon(byPrefixAndName.fas["eye-slash"]);
        }
    }

    const onKeyUp = (e) => {
        if (e.key === 'Enter' || e.keyCode === 13) {
            onEnterClicked?.()
        }
    }

    return (
        <div style={{ padding: "0px", width: width, position: "relative", height: height, marginTop: marginTop, marginBottom: marginBottom, display: "flex", justifyContent: "start", flexDirection: "column", marginLeft: marginLeft }}>


            <input ref={ref}
                autoComplete='off'
                step={0.1}
                className={getClassName(styleType)}
                placeholder={placeHolder}
                type={currentType}
                onKeyUp={(e) => onKeyUp(e)}
                onFocus={() => {
                    if (!keyboardClicked) {
                        if (keyboardRef.current)
                            keyboardRef.current.setInputElement(ref.current);
                        setSelected(true);
                    }
                    onFocus?.();
                    setKeyboardClicked(false);
                }}
                onBlur={() => {
                    if (typeOfInput !== "number") {
                        caretPosition.current = ref.current.selectionStart;
                    }
                    if (!keyboardClicked) {
                        setSelected(false);
                        keyboardRef.current.setInputElement(null);
                        onBlur?.();
                    } else {
                        ref.current.focus();
                    }

                }}
                onChange={() => onTextChanged()}
                style={{
                    fontSize: fontSize ? fontSize : 40,
                    outline: 0,
                    border: selected ? "1px solid #33FFC8" : "0",
                    boxShadow: selected ? "0 0 10px 2px #33FFC8AA" : "none",
                    width: "100%",
                    boxSizing: "border-box",
                    height: height,
                    paddingLeft: withLeftIcon.current ? "70px" : "40px",
                    paddingRight: isChat ? "130px" : withRightIcon.current ? "60px" : "",
                }}
            />

            {withLeftIcon.current && <FontAwesomeIcon className={styles.left_icon} icon={icon} />}

            {withLeftIcon.current && withRightIcon.current && rightIcon && <FontAwesomeIcon className={styles.right_icon} icon={rightIcon} onClick={() => ClickDeleteButton_Handler()} />}

            {!withLeftIcon.current && withRightIcon.current && <FontAwesomeIcon className={styles.right_icon} icon={rightIcon} onClick={() => ClickDeleteButton_Handler()} />}

            {type === "password" && <FontAwesomeIcon className={styles.right_icon} icon={rightIcon} onClick={() => ShowHidePassword_handler()} />}
        </div>
    );
})

export default New_InputTextComponent;

